import { Button } from '@ui/atoms/design-system';
import FdCalculatorView from '@components/Products/FixedDeposits/components/Calculator/FdCalculator';
import CalculatorLayout from '@components/Products/FixedDeposits/components/Layouts/CalculatorLayout';
import { fdReturnsCalculator } from '@components/Products/FixedDeposits/utils/helper';
import CalculatorHeader from '@components/Products/FixedDeposits/components/Calculator/CalculatorHeader';
import { fdRedirectTo } from '@components/Products/FixedDeposits/utils/utils';
import useWindowDimensions from '@hooks/useWindowDimensions';
import { triggerCustomEvent } from '@helpers/miscelleanous';
import { fdProductEvents } from '@helpers/enums/gaEventNameEnum';
import { Text } from '@ui/atoms';

const FDReturnsCalculator = ({ toggleModal }) => {
    const { width } = useWindowDimensions();
    const isMobile = width < 768;

    const handleOnClick = () => {
        triggerCustomEvent(fdProductEvents.CLICKED_FD_PRODUCT_BOOK_NOW);

        isMobile ? fdRedirectTo() : toggleModal();
    };
    return (
        <CalculatorLayout>
            <CalculatorHeader />
            <FdCalculatorView />
            <div className='flex flex-col items-center gap-4'>
                <Button
                    buttonText={fdReturnsCalculator.button}
                    buttonType="primary"
                    widthClass="w-full md:w-auto max-w-[415px] mx-auto md:max-w-none"
                    onClick={handleOnClick}
                />
                <Text
                    content={fdReturnsCalculator.disclaimer}
                    className="p6-regular text-center text-gray-500"
                />
            </div>
        </CalculatorLayout>
    );
};

export default FDReturnsCalculator;
